import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { semanticCapabilities } from '../data/semanticKnowledge';
import { easeOutStrong, fadeUp } from '../utils/motion';
import { SkpWorkflow } from '../components/semantic/SkpWorkflow';
import { SkpResearch } from '../components/semantic/SkpResearch';
import { SkpCapabilityFoundation } from '../components/semantic/SkpCapabilityFoundation';
import { SkpControls } from '../components/semantic/SkpControls';
import { SkpFoundation } from '../components/semantic/SkpFoundation';
import { SkpCTA } from '../components/semantic/SkpCTA';
import { SkpLlmTeaser } from '../components/semantic/SkpLlmTeaser';
export function SemanticKnowledgePage() {
  return <>
      <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-24" data-id="element-2403" data-mp="ly9xs3u1jxmq">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-2404" data-mp="qzpjly41m866">
          <h1 className="lg:col-span-6 font-heading font-extrabold text-5xl lg:text-6xl text-ink-dark leading-[1.05] tracking-tight" data-id="element-2405" data-mp="ty0x7ygqwnyy">
            Semantic Knowledge Platform
          </h1>
          <div className="lg:col-span-6" data-id="element-2406" data-mp="k1nyuna99lxv">
            <p className="text-xl text-ink-dark/80 leading-relaxed mb-5" data-id="element-2407" data-mp="k2z64x2wtbtq">
              A configurable system for structured content, shared concepts,
              connected evidence, knowledge graphs, semantic search, and
              AI-assisted research.
            </p>
            <p className="text-lg text-ink-muted leading-relaxed mb-8" data-id="element-2408" data-mp="17xil8bm7vx79">
              It turns scattered research and content into connected, usable
              knowledge — defining concepts and relationships, linking evidence
              across sources, and pairing AI-assisted discovery with expert
              review.
            </p>
            <a href="/contact" className="inline-flex items-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-2409" data-mp="3pw9qzzd2h83z">
              Request a Demo
              <ArrowRight size={18} data-id="element-2410" data-mp="3g66p19nywjti" />
            </a>
          </div>
        </motion.div>
      </section>

      <section className="bg-surface-bg py-20 lg:py-28" data-id="element-2411" data-mp="3l3ox6xu5uv0g">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2412" data-mp="375ijl3cn3rs8">
          <motion.h2 {...fadeUp} className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight mb-12" data-id="element-2413" data-mp="3b7dnmflygj9p">
            What the platform brings together
          </motion.h2>
          <dl className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 border-t border-line" data-id="element-2414" data-mp="325vxs5iqx37t">
            {semanticCapabilities.map(item => <motion.div key={item.title} {...fadeUp} className="border-b border-line py-8" data-id="element-2415" data-mp="veemwkdhxizs">
                <dt className="font-heading font-bold text-xl text-ink-dark mb-2" data-id="element-2416" data-mp="10d7zmakyl5yw">
                  {item.title}
                </dt>
                <dd className="text-ink-muted leading-relaxed" data-id="element-2417" data-mp="2fys5fnm1aeiv">{item.body}</dd>
              </motion.div>)}
          </dl>
        </div>
      </section>

      <SkpLlmTeaser data-id="element-2418" data-mp="2up96v6yo54fr" />
      <SkpWorkflow data-id="element-2419" data-mp="2pwfym93zrdyx" />
      <SkpResearch data-id="element-2420" data-mp="2pw69enqrtaua" />
      <SkpCapabilityFoundation data-id="element-2421" data-mp="2pvo4z3tyfqba" />
      <SkpControls data-id="element-2422" data-mp="2pud2d7c8wolr" />
      <SkpFoundation data-id="element-2423" data-mp="33nungwkky9dw" />
      <SkpCTA data-id="element-2424" data-mp="33n1nqfk1gk59" />
    </>;
}